export const event = (state) => {
  return state.event
}

export const oneCheckoutOpen = (state) => {
  return state.oneCheckoutOpen
}

export const checkoutByProduct = (state) => {
  return state.checkoutByProduct
}

export const loadingCheckout = (state) => {
  return state.loadingCheckout
}

export const eventPlaces = (state) => {
  return state.eventPlaces
}